module.exports = __webpack_public_path__ + "img/Phone.1f935024.svg";